
export default {
	procedure: {
		basicInformation: {
			NUMBER: 50,
			NAME: 400,
			DESCRIPTION: 4000,

			CONTACT_PERSON: 200,
			CONTACT_PERSON_PHONE: 20,

			PURCHASER_PHONE: 20,
			PURCHASER_FAX: 20,
			PURCHASER_EMAIL: 255,
			PURCHASER_ADDITIONAL_INFO: 500,

			EOD: 100,
			SINGLE_DEALING_JUSTIFICATION: 4000,
			ESTIMATION_BASE: 4000,
			FINANCIAL_SOURCE: 4000,
			TERM_DESCRIPTION: 1000,
			FULL_NAME: 200,
			EU_PROJECT_NUMBER: 100
		},
		contractor: {
			NAME: 1000,
			POSTCODE_PL: 6,
			POSTCODE: 50,
			EMAIL: 255,
			NIP_MIN: 5,
			NIP_MAX: 20,
			PESEL_PL: 11,
			NIP_PL: 10,
			CITY: 100,
			ADDRESS: 500
		},
		organization: {
			NAME: 500,
		},
		dealings: {
			NAME: 400,
			PLANNED_CONTRACTOR_NUMBER: 5
		},
		condition: {
			OTHER_NAME: 400,
		},
		criteriaSection: {
			NAME: 400
		},
		parameters: {
			NAME: 400
		},
		itemParameters: {
			NAME: 30
		},
		documents: {
			NAME: 255
		},
		correspondence: {
			SUBJECT: 255
		}
	},
}